import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Paper } from "@mui/material";
import { Text } from "@semcore/typography";
import { Flex } from "@semcore/flex-box";
import Divider from "@mui/material/Divider";
import Button from "@semcore/button";
import { Link } from "react-router-dom";
import Input from "@semcore/input";
import { useState, useMemo } from "react";
import ArrowLeftM from "@semcore/ui/icon/ArrowLeft/m";
import axios from "axios";
import {
  GET_WHITELABLE_CUSTOMDOMAIN,
  POST_WHITELABLE_CUSTOMDOMAIN,
} from "../../../services/constants";
import { ZustandStore } from "../../../store/zustand-store";
import AddProjectStore from "../../../store/AddProjectStore";
import FallbackLoader from "../../share/components/FallbackLoader";
import Alert from "@mui/material/Alert";
import { useEffect } from "react";
import { getUrlType } from "../../share/components/add-project-section/helper";
import { useBuyAddonHandler } from "../../share/custom-hook/useBuyAddonHandler";

const WhiteLabelCustomDomain = () => {
  const [domain, setDomain] = useState({
    name: "",
    isAdd: true,
  });
  const [msg, setMsg] = useState("");
  const email = localStorage.getItem("admin_mail");
  const { handleAddonPlan } = useBuyAddonHandler();

  const { customer_plan, plan_loaded } = ZustandStore((state) => state);
  const { showNotification } = AddProjectStore((state) => state);

  const isWhiteLabel = useMemo(() => {
    const planName = customer_plan?.plan_name?.toLowerCase();
    if (customer_plan.whitelabel_platform) {
      return {
        disabled: false,
        plan_type: null,
      };
    }

    if (planName === "rankspro lifetime plan") {
      return {
        disabled: true,
        plan_type: "plan addon",
      };
    }

    return {
      disabled: true,
      plan_type: "plan upgrade",
    };
  }, [customer_plan]);

  function handleClick(event) {
    event.preventDefault();
    console.info("You clicked a breadcrumb.");
  }

  const handleCheckCustomDomain = async () => {
    if (!email) return;
    try {
      const resp = await axios.get(GET_WHITELABLE_CUSTOMDOMAIN(email));
      const data = resp.data;
      if (data?.length === 0) {
        setDomain({
          name: "",
          isAdd: false,
        });
      } else {
        setDomain({
          name: data.domain,
          isAdd: true,
        });
      }
    } catch (error) {}
  };

  useEffect(() => {
    handleCheckCustomDomain();
  }, [email]);

  const handleCustomDomain = async () => {
    if (!domain.name || domain.name.trim() === "") {
      showNotification({
        message: "Domain name is required!",
        severity: "error",
      });
      return;
    }
    if (getUrlType(domain.name) === "Invalid") {
      showNotification({
        message: "Please enter a valid domain name",
        severity: "error",
      });
      return;
    }
    try {
      const resp = await axios.post(POST_WHITELABLE_CUSTOMDOMAIN(), {
        domain: domain.name,
        email,
      });
      handleCheckCustomDomain();
      setMsg(resp?.data?.msg || "");
      showNotification({
        message: resp?.data?.msg || "Custom domain added successfully",
        severity: "success",
      });
    } catch (error) {
      showNotification({
        message: "Error creating custom domain",
        severity: "error",
      });
    }
  };

  const addonLink = `https://buy.stripe.com/00w3cv4wi8Ik1DvgA90Fi1a?prefilled_email=${email}`;

  return (
    <>
      {plan_loaded ? (
        <>
          <Link style={{ color: "#00000099" }} to="/account/whitelabel">
            <Button h={34} w={34} mt={3}>
              <Button.Addon>
                <ArrowLeftM />
              </Button.Addon>
              <Button.Text>Back</Button.Text>
            </Button>
          </Link>
          <div role="presentation" onClick={handleClick} className="my-3">
            <Breadcrumbs aria-label="breadcrumb">
              <Link style={{ color: "#00000099" }} to="/account">
                Account
              </Link>
              <Link style={{ color: "#00000099" }} to="/account/whitelabel">
                White Label
              </Link>
              <Typography sx={{ color: "text.primary" }}>
                Custom domain name
              </Typography>
            </Breadcrumbs>
          </div>
          {isWhiteLabel.disabled && (
            <Alert severity="warning" className="mb-3">
              {isWhiteLabel.plan_type === "plan upgrade" ? (
                <>
                  <Link
                    style={{ color: "#6a3be4" }}
                    to="/upgrade"
                    className="anchor-hover"
                  >
                    Upgrade
                  </Link>{" "}
                  your plan(Ultimate Plan) to unlock full branding control, or{" "}
                  <span
                    style={{ color: "#6a3be4" }}
                    className="anchor-hover"
                    onClick={() => handleAddonPlan(addonLink)}
                  >
                    Buy Addon.
                  </span>{" "}
                </>
              ) : (
                <>
                  <span
                    style={{ color: "#6a3be4" }}
                    onClick={() => handleAddonPlan(addonLink)}
                    className="anchor-hover"
                  >
                    Buy Addon
                  </span>{" "}
                  to unlock full branding control.
                </>
              )}
            </Alert>
          )}
          <Paper
            elevation={3}
            className="p-3 mt-3"
            sx={{ boxShadow: "none", border: "2px solid #C4C7CF" }}
          >
            <Typography variant="h5" gutterBottom>
              Custom domain name
            </Typography>

            <Text tag="label" size={300} mb={4} wMax={700}>
              You can personalize the way you access the RanksPro platform by
              using a custom domain, such as{" "}
              <span style={{ color: "#6254FF" }}>
                <b>yourbrand.example.com</b>
              </span>
              . Alternatively, you can fully white-label the platform under your
              own domain name—without any mention of RanksPro. No matter which
              option you choose, a{" "}
              <span style={{ color: "#6254FF" }}>
                <b>free SSL certificate</b>
              </span>{" "}
              is included to ensure your White Label SEO platform is secure and
              branded entirely under your identity.
            </Text>
            <Divider />
            <Typography variant="subtitle1" gutterBottom marginTop={2}>
              Use Your Own Custom Domain Name:
            </Typography>
            <Text tag="label" size={300} wMax={700}>
              To provide access to the platform without showing RanksPro in the
              URL, you can connect your own domain.
              <br />
              1. Go to your domain's DNS settings.
              <br />
              2. Create a{" "}
              <span style={{ color: "#6254FF" }}>
                <b>CNAME</b>
              </span>{" "}
              record pointing to app.rankspro.io.
              <br />
              3. Enter your custom domain below without including http:// or
              www. Example:{" "}
              <span style={{ color: "#6254FF" }}>
                <b>yourbrand.example.com</b>
              </span>
              <br />
              Once set up, your white-labeled platform will be accessible under
              your brand, with no reference to RanksPro in the address bar.
            </Text>
            <Flex mt={3}>
              <Flex direction="column" gap={1}>
                <Input h={40} wMax={360} disabled={domain.isAdd}>
                  <Input.Value
                    value={domain.name}
                    placeholder=""
                    type="text"
                    autoComplete="off"
                    onChange={(value) => {
                      setDomain((pre) => ({
                        ...pre,
                        name: value,
                      }));
                    }}
                  />
                </Input>
                {msg && (
                  <Text size={200} color={"green-500"} ml={2}>
                    {msg}
                  </Text>
                )}
              </Flex>
              <Button
                disabled={isWhiteLabel.disabled || domain.isAdd}
                h={40}
                ml={2}
                px={2}
                className="white-lable-btn"
                onClick={handleCustomDomain}
                title="To activate an SSL certificate, first enter a domain name and save the changes."
              >
                {domain.isAdd && domain.name != ""
                  ? "Already Аctivated"
                  : "Аctivate"}
              </Button>
            </Flex>
          </Paper>
        </>
      ) : (
        <FallbackLoader />
      )}
    </>
  );
};

export default WhiteLabelCustomDomain;
